import type {
  IConfLicencia,
  IResultadoImportacionLicencias
} from '@/modules/Configuracion/interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
import { BaseService } from '@/modules/Core/services/BaseService'

export class LicenciaService extends BaseService<IConfLicencia> {
  constructor() {
    super({
      baseUrl: 'system/license/'
    })
  }

  async importarExcel(
    archivo: File
  ): Promise<AxiosResponse<IResponseApi<IResultadoImportacionLicencias>>> {
    const datos = new FormData()
    datos.append('file', archivo)
    return this.http
      .post<IResponseApi<IResultadoImportacionLicencias>>(
        '/upload-excel',
        datos,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      .catch(this.errorHandle)
  }
}
